var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-response-icon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-product-review__response--svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" role=\"img\" aria-hidden=\"true\">\n    <style>\n        .product-reviews-response-cls-1 { fill: #05728c; }\n        .product-reviews-response-cls-2 { fill: #fff; }\n    </style>\n    <circle class=\"product-reviews-response-cls-1\" cx=\"15\" cy=\"15\" r=\"15\"></circle>\n    <path class=\"product-reviews-response-cls-2\" d=\"M11.08,17.44,9.67,20.72c.95,0,1.41,0,1.8,0a.64.64,0,0,1,.56.7.6.6,0,0,1-.56.65A13.59,13.59,0,0,0,9,21.83a12.5,12.5,0,0,0-2.41.2A.59.59,0,0,1,6,21.38a.63.63,0,0,1,.57-.7c.38,0,.69,0,1.72,0l6.2-14.21c.11-.35.22-.54.6-.54s.46.16.62.54l6,14.21c1.23,0,1.35,0,1.73,0a.65.65,0,0,1,.57.7.6.6,0,0,1-.57.65,16.12,16.12,0,0,0-3.1-.2h0a17.62,17.62,0,0,0-3.06.2.61.61,0,0,1-.57-.65.65.65,0,0,1,.57-.7c.39,0,.5,0,1.61,0l-1.38-3.28Zm5.81-1.34L14.33,10,11.65,16.1Z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-response-icon.j2"] , dependencies)